// extracted by mini-css-extract-plugin
export default {"reasonToSend":"headers_reasonToSend__c8BQp","featureContent":"headers_featureContent__gAS-F","reason":"headers_reason__K5dep","closeCollection":"headers_closeCollection__ziXIH"};